module.exports = __webpack_public_path__ + "static/media/power-off-solid.b231083f.svg";